import { ISOCode } from './worldMap.types';

export const colorChosenCountries = (
  chosenCountries: ISOCode[],
  chosenCountriesByRegion: ISOCode[]
): void => {
  const world = document.getElementById('World');

  if (world) {
    const allChosen =
      chosenCountries.length > 0
        ? chosenCountries
        : [...chosenCountries, ...chosenCountriesByRegion];
    Array.from(document.getElementsByClassName('country')).forEach(element => {
      if ((allChosen as string[]).includes(element.id)) {
        element.setAttribute('class', 'country country-selected');
        // Move selected countries to the bottom (this way it is guaranteed that its border is drawn on top).
        element.remove();
        world.appendChild(element);
      } else {
        element.setAttribute('class', 'country');
      }
    });
  }
};
